<div class="card sessions-group mt-3">
    <div class="card-body">
        <div class="row">
            <div class="col-md-8">
                <h5 class="card-title main-blue">
                    {{ "CampDetails.Pricing" | translate }}
                </h5>
            </div>
            <div class="col-md-4">
                @if (state.canEdit | async) {
                    <button
                        class="btn btn-success btn-action pull-right"
                        [disabled]="isAnyItemEdited"
                        hznTestId="discounts-add"
                        (click)="add()"
                    >
                        {{ "General.Add" | translate }}
                    </button>
                }
            </div>
        </div>
        <div class="card-text grid-table">
            <div>
                <div class="row table-header-row">
                    <div class="col-md-2">
                        {{ "CampDetails.DiscountType" | translate }}
                    </div>
                    <div class="col-md-2">
                        {{ "CampDetails.DiscountName" | translate }}
                    </div>
                    <div class="col-md-4">
                        {{ "CampDetails.DiscountDetails" | translate }}
                    </div>
                    <div class="col-md-2 text-center">
                        {{ "CampDetails.DiscountValue" | translate }}
                    </div>
                    <div class="col-md-2"></div>
                </div>
                @for (
                    discount of form.controls.items["controls"]
                        | orderby: "value.type";
                    track discount
                ) {
                    <div>
                        @if (!isEdited(discount)) {
                            <app-discount-details hznTestId="discount-row"
                                [form]="discount"
                                (removed)="onRemoved($event)"
                            ></app-discount-details>
                        }
                        @if (isEdited(discount)) {
                            <app-discount-details-edit hznTestId="discount-edit-row"
                                [form]="discount"
                                (canceled)="onCancel($event)"
                                [context]="context"
                            ></app-discount-details-edit>
                        }
                    </div>
                }
            </div>
        </div>
    </div>
</div>
